import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const BookingsTabSkeleton = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <Skeleton className="h-10 w-[160px]" />

      <div className="flex gap-2">
        <Skeleton className="h-10 w-[160px]" />
        <Skeleton className="h-10 w-[185px]" />
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 items-end">
      {[...Array(5)].map((_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>

    <Card className="p-4">
      <div className="grid grid-cols-12 gap-4 px-2 pb-4">
        {[...Array(12)].map((_, i) => (
          <Skeleton key={`header-${i}`} className="h-5 w-full" />
        ))}
      </div>

      <div className="space-y-4">
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    </Card>
  </div>
);

export default BookingsTabSkeleton;
